import { render, staticRenderFns } from "./RegisterCard.vue?vue&type=template&id=73c13e88&"
import script from "./RegisterCard.vue?vue&type=script&lang=js&"
export * from "./RegisterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusTitle: require('/~/src/modules/opus/components/Title.vue').default,RegisterBenefits: require('/~/src/modules/mobiilitukku/components/RegisterBenefits.vue').default,OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default,OpusCard: require('/~/src/modules/opus/components/Card.vue').default})
